/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoContattoDTO
 */
export interface TipoContattoDTO {
    /**
     * 
     * @type {number}
     * @memberof TipoContattoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TipoContattoDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the TipoContattoDTO interface.
 */
export function instanceOfTipoContattoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TipoContattoDTOFromJSON(json: any): TipoContattoDTO {
    return TipoContattoDTOFromJSONTyped(json, false);
}

export function TipoContattoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoContattoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
    };
}

export function TipoContattoDTOToJSON(value?: TipoContattoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'descrizione': value.descrizione,
    };
}

